import { useAppContext } from '../../appProvider/contextProvider';
import Lock from '../../assets/images/lock.svg';

const PremiumLock = ({isMenu}) => {

    const {setPricingPopupOpen} = useAppContext();

    const onClickLock = () => {
        if(!isMenu) {
            setPricingPopupOpen(true)
        }
    }

    return <>
        <div onClick={onClickLock} className={!isMenu ? 'premium-lock-bg bg-grey ml-2' : 'premium-lock-bg '}>
            {!isMenu && <img src={Lock} height="12px" width="12px" />}
            {isMenu && <i className='icon icon-lock icon-gold'></i>}
            { !isMenu && <span>UNLOCK FREE TRIAL</span>}
        </div>
    </>
}


export default PremiumLock;